import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se l'email esiste, riceverai le istruzioni.");
    } catch (err) {
      // sempre generico per privacy
      setSent(true);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="text-xs tracking-widest uppercase text-primary">Password dimenticata</div>
      <h1 className="font-display text-3xl mt-2">Recupero password</h1>

      {sent ? (
        <div className="mt-6 bg-white border border-border rounded-xl p-6">
          <p className="text-sm text-foreground/80">Se l'indirizzo <b>{email}</b> è associato a un account, ti abbiamo inviato un'email con il link per reimpostare la password.</p>
          <p className="text-xs text-foreground/60 mt-3">Il link scade dopo 60 minuti.</p>
          <Button asChild variant="outline" className="mt-6 rounded-full"><Link to="/login">Torna al login</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 bg-white border border-border rounded-xl p-6 space-y-4">
          <p className="text-sm text-foreground/70">Inserisci l'email associata al tuo account. Ti invieremo il link per reimpostare la password.</p>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1" data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-full h-11" data-testid="forgot-submit">
            {busy ? "Invio..." : "Invia link di recupero"}
          </Button>
          <div className="text-sm text-center text-foreground/60">
            <Link to="/login" className="text-primary">Torna al login</Link>
          </div>
        </form>
      )}
    </div>
  );
}
